<template>
  <figure class="image is-fullwidth is-hidden-mobile">
    <img
      v-if="employer"
      alt="rojgari-signup"
      :src="`/images/account/employer.png`"
      class="account-image"
    />
    <img
      v-else
      alt="rojgari-signup"
      :src="`/images/account/rojgaridialog.png`"
      class="account-image"
    />
  </figure>
</template>
<script>
export default {
  props: {
    employer: {
      type: Boolean
    }
  }
}
</script>
<style scoped>
.account-image {
  width: 500px;
  height: 500px;
  object-fit: cover;
  border-radius: 6px;
}
</style>
